import { ConversationSurface } from "./chatbox/conversation-surface"
import "./style.scss"

export default function AgentChat() {
  // The conversation controller + selected model now live in KellyChatProvider (wraps this route in
  // routes.jsx, APP-3369) so the top-bar tab strip shares the same source; the surface just consumes it.
  return <div className="agent-chat-page">
    <ConversationSurface />
  </div>
}
